import { Component, Input, OnInit } from '@angular/core';

import { SnAlarm, SnAmberAlertPersonType } from '@lib/api/entities';

@Component({
  selector: 'sn-amber-alert-details',
  templateUrl: './amber-alert-details.component.html',
  styleUrls: ['./amber-alert-details.component.scss'],
})
export class SnAmberAlertDetailsComponent implements OnInit {
  @Input()
  public alarm: SnAlarm;

  public suspectPerson: SnAmberAlertPersonType;
  public missingPerson: SnAmberAlertPersonType;

  constructor() {}

  public ngOnInit(): void {
    this.suspectPerson = this.alarm.details['personList'].find(
      (p) => p.personType === 'SuspectPerson',
    );
    this.missingPerson = this.alarm.details['personList'].find(
      (p) => p.personType === 'MissingChild',
    );
  }
}
